import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../helpers/url_helper";

import { post, put } from "../../helpers/api_helper";

export const getPromoList = createAsyncThunk(
  "getPromoList",
  async ({ data, callback }, Thunk) => {
    try {
      const url = URL.GET_PROMO_CODE;
      let response = await post(url, data);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updatePromoCode = createAsyncThunk(
  "updatePromoCode",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await put(URL.EDIT_PROMO_CODE + data?._id, data);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const AddPromo = createAsyncThunk(
  "AddPromo",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.ADD_PROMO_CODE, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error action");
      callback && callback(error || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  },
);
